import { Children } from "react";
import styles from "./ArticleWell.module.scss";
import cx from "classnames";

const ArticleWell = ({
  children,
  borderBottom,
}: {
  children: React.ReactNode;
  borderBottom?: boolean;
}) => {
  if (Children.toArray(children).length === 0) return null;
  return (
    <div className={cx(styles.root, borderBottom && styles.borderBottom)}>
      {children}
    </div>
  );
};

export default ArticleWell;
